import React from "react"
import { Badge } from "reactstrap"
import "./bd-products.css"
function ActiveInactive(props) {
  let status = props.data.product_status ? 1 : 0
  return (
    <>
      {status ? (
        <Badge
          color="success"
          className="cursor-pointer"
          pill
          onClick={() => {
            props.callChangeProductStatus(props.data.prod_id)
          }}
        >
          Active
        </Badge>
      ) : (
        <Badge
          className="cursor-pointer"
          color="danger"
          pill
          onClick={() => {
            props.callChangeProductStatus(props.data.prod_id)
          }}
        >
          Inactive
        </Badge>
      )}
    </>
  )
}

export default ActiveInactive
